import { HOME, PROFILE, USERS_LIST, VIEW_SAMPLE } from "../routes";
import { ROLES } from "./Strings";

export const HEADER_ITEMS = {
    [ROLES.ADMIN]: [
        {
            name:"Projects",
            route:HOME,
        },
        {
            name:"Profile",
            route:PROFILE,
        },
        {
            name: "Users",
            route: USERS_LIST,
        },
        {
            name:"Document Template",
            route: VIEW_SAMPLE
        }
    ],
    [ROLES.USER]: [
        {
            name:"Projects",
            route:HOME,
        },
        {
            name:"Profile",
            route:PROFILE,
        },
        {
            name:"Document Template",
            route: VIEW_SAMPLE
        }
    ],
    [ROLES.CUSTOMER]: [
        {
            name:"Projects",
            route:HOME,
        },
        {
            name:"Profile",
            route:PROFILE,
        }
    ]
};